import { createContext } from "react";

export let ToDoListContext = createContext();
